/**
 * Vanilla JavaScript error logger for non-React contexts
 * Sends error messages to Sentry when available, falls back to console
 *
 * @param {string} errorMessage - The error message to log
 * @param {string} level - The severity level (error, warning, info, debug)
 */
export const logError = (errorMessage, level = "error") => {
	// Check if we're in a browser environment and Sentry is loaded
	if (typeof window !== "undefined" && window.Sentry) {
		window.Sentry.captureMessage(errorMessage, { level });
	} else {
		// Fallback to console.error when Sentry is not available
		console.error(errorMessage);
	}
};
